import { Dialog, type DialogProps, DialogTitle, Divider } from '@shared/components';

import { TemporarilyCloseExamEventLogic } from '../temporarily-close-exam-event-logic';

export interface TemporarilyCloseExamEventModalProps extends Omit<DialogProps, 'onSubmit'> {
  onSubmit: (reason: string) => void;
  onClose: () => void;
}

export default function TemporarilyCloseExamEventModal(
  props: Readonly<TemporarilyCloseExamEventModalProps>,
) {
  const { onSubmit, onClose, ...restProps } = props;

  return (
    <Dialog {...restProps} maxWidth='sm' onClose={onClose}>
      <DialogTitle onClose={onClose}>ยืนยันการปิดรับสมัครชั่วคราว?</DialogTitle>
      <Divider />
      <TemporarilyCloseExamEventLogic onSubmit={onSubmit} onClose={onClose} />
    </Dialog>
  );
}
